import { render, staticRenderFns } from "./MarcaVeiculoForm.vue?vue&type=template&id=d4892e5c"
import script from "./MarcaVeiculoForm.vue?vue&type=script&lang=js"
export * from "./MarcaVeiculoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports